import { render, staticRenderFns } from "./DictionaryAddModal.vue?vue&type=template&id=0bf80a55&"
import script from "./DictionaryAddModal.vue?vue&type=script&lang=js&"
export * from "./DictionaryAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports